import { ThemeProvider, ToastProvider, TooltipProvider } from '@insightai/ui'
import { Route, Routes } from 'react-router-dom'
import { SiteFooter } from './components/SiteFooter'
import { StickyNav } from './components/StickyNav'
import { routes } from './routes'

/**
 * Marketing shell.
 *
 * Nav and footer render on every route including the auth pages, because the auth
 * screens are deep-linkable pages rather than true modals (M00-20) and a visitor
 * who lands on /auth/login from a shared link still needs a way back to the site.
 *
 * NO MotionProvider here, deliberately. Framer Motion costs ~20KB gz on first
 * paint, and marketing motion polish (M00-13) is an Optional task that is not
 * built. Every animation currently on the site is a CSS keyframe from the token
 * layer, which already honours `prefers-reduced-motion` globally. When M00-13 is
 * picked up, the provider belongs inside the component that needs it, not at the
 * root of a page whose whole job is a fast first paint.
 */
export function App() {
  return (
    <ThemeProvider>
      <TooltipProvider>
        <ToastProvider>
          <div className="flex min-h-screen flex-col bg-surface-base text-text-primary">
            <a href="#main-content" className="skip-link">
              Skip to main content
            </a>
            <StickyNav />
            <main id="main-content" tabIndex={-1} className="flex-1">
              <Routes>
                {routes.map((route) => (
                  <Route key={route.path} path={route.path} element={route.element} />
                ))}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <SiteFooter />
          </div>
        </ToastProvider>
      </TooltipProvider>
    </ThemeProvider>
  )
}

function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center">
      <h1 className="text-h1">We couldn't find that page</h1>
      <p className="pt-2 text-body text-text-secondary">
        The link may be out of date. Try the navigation above.
      </p>
    </div>
  )
}
